import { Contract } from "@/types/contracts";

interface ContractTermsProps {
  contract: Contract;
}

export const ContractTerms = ({ contract }: ContractTermsProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-4">
        <h4 className="font-medium">Termes du contrat:</h4>
        <p className="text-sm text-gray-600">
          Objet : Ce contrat précise les conditions relatives aux retenues sur salaire, aux écarts d'inventaire, aux différences de comptage, ainsi qu'aux conditions de résiliation.
        </p>

        {contract.terms.salary_deductions && (
          <div className="space-y-2">
            <h5 className="font-medium">1. Retenues sur Salaire</h5>
            <p className="text-sm text-gray-600">
              En cas de différence de comptage non justifiée de manière valable, l'employeur se réserve le droit d'effectuer une retenue équivalente à la somme manquante sur le salaire de l'employé.
            </p>
          </div>
        )}

        {contract.terms.inventory_discrepancies && (
          <div className="space-y-2">
            <h5 className="font-medium">2. Écarts d'Inventaire</h5>
            <p className="text-sm text-gray-600">
              Si un inventaire révèle des manquements de produits en stock sans justificatif valable, l'employé sera tenu pour responsable. Des sanctions pourront être appliquées, incluant des retenues sur salaire et des mesures disciplinaires.
            </p>
          </div>
        )}

        {contract.terms.counting_differences && (
          <div className="space-y-2">
            <h5 className="font-medium">3. Différences de Comptage Répétées</h5>
            <p className="text-sm text-gray-600">
              En cas d'erreurs répétées de comptage sans amélioration, malgré des avertissements, l'employeur se réserve le droit de procéder à des sanctions pouvant aller jusqu'au licenciement.
            </p>
          </div>
        )}
      </div>

      {contract.employee_signature && (
        <div className="space-y-2">
          <h4 className="font-medium">Signature:</h4>
          <div className="text-sm text-gray-500 mb-2">
            Signé le {new Date(contract.updated_at).toLocaleDateString()}
          </div>
          <div className="border rounded-md p-2">
            <img 
              src={contract.employee_signature} 
              alt="Signature de l'employé"
              className="max-h-24 object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};